import { Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from '@core/services/settings.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ProductColorViewModel } from '@models/api.models';

type ColorValue = {
    key?: string;
    text?: string;
};

@Pipe({
    name: 'getMatchColor',
    standalone: true
})
export class GetMatchColorPipe implements PipeTransform {
    constructor(private settingsService: SettingsService) {}

    /**
     * Will get the color from the umbraco settings for the given colorId
     *
     * NOTE: sooner or later this will be removed because for this context we don't use anymore the hexColor or the umbraco settings
     * @param value - the color key id
     * @returns the color from the settings, if for some reason the color is not found in umbraco product settings, we use the value from the color we are trying to find
     */
    transform(value?: ColorValue): Observable<ProductColorViewModel | undefined> {
        return this.settingsService.settings$.pipe(
            map(({ productSettings }) => productSettings),
            map(productSettings => productSettings?.productColors),
            map(
                productColors =>
                    productColors?.find((color: ProductColorViewModel) => color.colorId === value?.key) ?? {
                        colorName: value?.text || '',
                        colorId: value?.key || '',
                        colorHexValue: ''
                    }
            )
        );
    }
}
